export default __webpack_public_path__ + "static/media/slider-img7.ac1cbed1.png";